<template>
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.93556 7.584H11.0716V16H9.93556V7.584ZM10.5116 5.744C10.2769 5.744 10.0796 5.664 9.91956 5.504C9.75956 5.344 9.67956 5.152 9.67956 4.928C9.67956 4.71467 9.75956 4.528 9.91956 4.368C10.0796 4.208 10.2769 4.128 10.5116 4.128C10.7462 4.128 10.9436 4.208 11.1036 4.368C11.2636 4.51733 11.3436 4.69867 11.3436 4.912C11.3436 5.14667 11.2636 5.344 11.1036 5.504C10.9436 5.664 10.7462 5.744 10.5116 5.744Z" fill="white"/>
<circle cx="10.5" cy="10.5" r="10" stroke="white"/>
</svg>
</template>

<script>
export default {}
</script>